import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MenuIcon from '@mui/icons-material/Menu';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import BadgeIcon from '@mui/icons-material/Badge';
import FlatwareIcon from '@mui/icons-material/Flatware';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import HomeIcon from "@mui/icons-material/Home";
export default function ButtonAppBar() {
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };


  const list = (anchor) => (
      <Box
          sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
          role="presentation"
          onClick={toggleDrawer(anchor, false)}
         onKeyDown={toggleDrawer(anchor, false)}
      >
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={cateringsMenu}>
              <ListItemIcon>
                <FastfoodIcon />
              </ListItemIcon>
              <ListItemText primary={"Menu"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={PreOrderBox}>
              <ListItemIcon>
                <FastfoodIcon />
              </ListItemIcon>
              <ListItemText primary={"MealBox"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={ProductMenu}>
              <ListItemIcon>
                <HomeIcon />
              </ListItemIcon>
              <ListItemText primary={"Products"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={cateringsEnquiry} color="inherit">
              <ListItemIcon>
                <MenuBookIcon />
              </ListItemIcon>
              <ListItemText primary={"Order Enquiry"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={cateringOrders} color="inherit">
              <ListItemIcon>
                <FlatwareIcon />
              </ListItemIcon>
              <ListItemText primary={"Catering Orders"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={employee} color="inherit">
              <ListItemIcon>
                <BadgeIcon/>
              </ListItemIcon>
              <ListItemText primary={"Employee"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton onClick={logoutUser} color="inherit">
              <ListItemIcon>
                <PermContactCalendarIcon />
              </ListItemIcon>
              <ListItemText primary={"LogOut"} />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton onClick={register}>
              <ListItemIcon>
                <InboxIcon />
              </ListItemIcon>
              <ListItemText primary={"Register"} />
            </ListItemButton>
          </ListItem>
        </List>
      </Box>
  );

  const {logout} = useAuth()
  const navigate = useNavigate();

  const logoutUser = () => {
    logout()
    navigate("/login")
  }
  const register = () => {
    logout()
    navigate("/registration")
  }
  const cateringsMenu=() =>{
    navigate("/cateringsmenu")
  }
  const cateringsEnquiry=() =>{
    navigate("/cateringsEnquiry")
  }
  const cateringOrders=() =>{
    navigate("/cateringOrders")
  }
  const employee=() =>{
    navigate("/employee")
  }
  const ProductMenu = () => {
    navigate("/productlist")
  }
  const PreOrderBox = () => {
    navigate("/preorderbox")
  }
  const Home = () => {
    navigate("/home")
  }
  return (

          <div>

            <Box sx={{ flexGrow: 1 }}>
              <AppBar position="static" sx={{ backgroundColor: 'lightblue' }}>
                <Toolbar>
                  <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2 }}
                  >
                   <MenuIcon  onClick={
                     toggleDrawer("left", true)
                   }/>
                    <Drawer
                        anchor={"left"}
                        open={state["left"]}
                        onClose={toggleDrawer("left", false)}
                    >
                      {list("left")}
                    </Drawer>
                  </IconButton>
                  <Typography variant="h4" component="div" sx={{ flexGrow: 1 }}>

                  </Typography>
                </Toolbar>
              </AppBar>
            </Box>
    </div>
  );
}
